export default {
  RESET_SCROLL_TRIGGER(state) {
    state.hasTriggeredScroll = false;
  },

  SET_SCROLL_TRIGGERED(state) {
    state.hasTriggeredScroll = true;
  },
};
